export default {
  "content": "<path d=\"M20.914 2.5l-3.043 3.043 3.043 3.043L19.5 10l-3.043-3.043L13.414 10 12 8.586l3.043-3.043L12 2.5l1.414-1.414 3.043 3.043L19.5 1.086 20.914 2.5zM10 4H6v16h1v2H5a1 1 0 01-1-1V3a1 1 0 011-1h5v2zM11 22H9v-2h2v2zM15 22h-2v-2h2v2zM20 21a1 1 0 01-1 1h-2v-2h1v-8h2v9z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};